const ArgumentType = require('../../extension-support/argument-type');
const BlockType = require('../../extension-support/block-type');
const Cast = require('../../util/cast');

class Scratch3MadBotPhysicsLab {
    constructor (runtime) {
        this.runtime = runtime;

        this.physicsOn = false;
        this.lastStepTime = null;
        this.physicsTimer = null;

        this.gravityOn = true;
        this.gravityStrength = 100;
        this.gravityDirection = 'down';

        this.stageBoundaryOn = true;
        this.boundaryBounce = 0.8;

        this.objects = new Map();

        this.runtime.on('PROJECT_STOP_ALL', () => {
            this.physicsOn = false;
            this.lastStepTime = null;
            this._stopLoop();
        });
    }

    _startLoop () {
        if (this.physicsTimer) return;

        this.lastStepTime = Date.now();

        this.physicsTimer = setInterval(() => {
            this._step();
        }, 1000 / 60);
    }

    _stopLoop () {
        if (this.physicsTimer) {
            clearInterval(this.physicsTimer);
            this.physicsTimer = null;
        }

        this.lastStepTime = null;
    }

    getInfo () {
        return {
            id: 'madbotPhysicsLab',
            name: 'MadBot Physics Lab',
            color1: '#5B3BFF',
            color2: '#4325D9',
            color3: '#2D18A8',

            blocks: [
                {
                    blockType: BlockType.LABEL,
                    text: 'Physics Setup'
                },
                {
                    opcode: 'turnPhysicsEngine',
                    blockType: BlockType.COMMAND,
                    text: 'turn physics engine [STATE]',
                    arguments: {
                        STATE: {
                            type: ArgumentType.STRING,
                            menu: 'onOffMenu',
                            defaultValue: 'on'
                        }
                    }
                },
                {
                    opcode: 'makePhysicsObject',
                    blockType: BlockType.COMMAND,
                    text: 'make this sprite [TYPE] physics object',
                    arguments: {
                        TYPE: {
                            type: ArgumentType.STRING,
                            menu: 'objectTypeMenu',
                            defaultValue: 'dynamic'
                        }
                    }
                },
                {
                    opcode: 'removePhysicsObject',
                    blockType: BlockType.COMMAND,
                    text: 'remove physics from this sprite'
                },
                {
                    opcode: 'resetThisPhysics',
                    blockType: BlockType.COMMAND,
                    text: 'reset physics values of this sprite'
                },
                {
                    opcode: 'clearAllPhysics',
                    blockType: BlockType.COMMAND,
                    text: 'clear all physics objects'
                },

                {
                    blockType: BlockType.LABEL,
                    text: 'Motion'
                },
                {
                    opcode: 'setVelocityXY',
                    blockType: BlockType.COMMAND,
                    text: 'set velocity x [VX] y [VY]',
                    arguments: {
                        VX: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 100
                        },
                        VY: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 0
                        }
                    }
                },
                {
                    opcode: 'changeVelocityXY',
                    blockType: BlockType.COMMAND,
                    text: 'change velocity x by [VX] y by [VY]',
                    arguments: {
                        VX: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 10
                        },
                        VY: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 0
                        }
                    }
                },
                {
                    opcode: 'setSpeedDirection',
                    blockType: BlockType.COMMAND,
                    text: 'set speed [SPEED] direction [DIR]',
                    arguments: {
                        SPEED: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 100
                        },
                        DIR: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 90
                        }
                    }
                },
                {
                    opcode: 'setAccelerationXY',
                    blockType: BlockType.COMMAND,
                    text: 'set acceleration x [AX] y [AY]',
                    arguments: {
                        AX: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 0
                        },
                        AY: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 0
                        }
                    }
                },
                {
                    opcode: 'launchSprite',
                    blockType: BlockType.COMMAND,
                    text: 'launch with speed [SPEED] angle [ANGLE]',
                    arguments: {
                        SPEED: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 150
                        },
                        ANGLE: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 45
                        }
                    }
                },
                {
                    opcode: 'stopMotion',
                    blockType: BlockType.COMMAND,
                    text: 'stop physics motion'
                },

                {
                    blockType: BlockType.LABEL,
                    text: 'Gravity'
                },
                {
                    opcode: 'turnGravity',
                    blockType: BlockType.COMMAND,
                    text: 'turn gravity [STATE]',
                    arguments: {
                        STATE: {
                            type: ArgumentType.STRING,
                            menu: 'onOffMenu',
                            defaultValue: 'on'
                        }
                    }
                },
                {
                    opcode: 'useGravityForSprite',
                    blockType: BlockType.COMMAND,
                    text: 'use gravity for this sprite [STATE]',
                    arguments: {
                        STATE: {
                            type: ArgumentType.STRING,
                            menu: 'onOffMenu',
                            defaultValue: 'on'
                        }
                    }
                },
                {
                    opcode: 'setGravityStrength',
                    blockType: BlockType.COMMAND,
                    text: 'set gravity strength [G]',
                    arguments: {
                        G: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 100
                        }
                    }
                },
                {
                    opcode: 'setGravityDirection',
                    blockType: BlockType.COMMAND,
                    text: 'set gravity direction [DIR]',
                    arguments: {
                        DIR: {
                            type: ArgumentType.STRING,
                            menu: 'gravityDirectionMenu',
                            defaultValue: 'down'
                        }
                    }
                },

                {
                    blockType: BlockType.LABEL,
                    text: 'Force and Mass'
                },
                {
                    opcode: 'setMass',
                    blockType: BlockType.COMMAND,
                    text: 'set mass to [MASS] kg',
                    arguments: {
                        MASS: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 1
                        }
                    }
                },
                {
                    opcode: 'applyForceXY',
                    blockType: BlockType.COMMAND,
                    text: 'apply force x [FX] y [FY]',
                    arguments: {
                        FX: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 50
                        },
                        FY: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 0
                        }
                    }
                },
                {
                    opcode: 'applyForceDirection',
                    blockType: BlockType.COMMAND,
                    text: 'apply force [FORCE] direction [DIR]',
                    arguments: {
                        FORCE: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 50
                        },
                        DIR: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 90
                        }
                    }
                },

                {
                    blockType: BlockType.LABEL,
                    text: 'Friction and Bounce'
                },
                {
                    opcode: 'setFriction',
                    blockType: BlockType.COMMAND,
                    text: 'set friction to [FRICTION]',
                    arguments: {
                        FRICTION: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 0.03
                        }
                    }
                },
                {
                    opcode: 'setAirResistance',
                    blockType: BlockType.COMMAND,
                    text: 'set air resistance to [AIR]',
                    arguments: {
                        AIR: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 0.01
                        }
                    }
                },
                {
                    opcode: 'setBounce',
                    blockType: BlockType.COMMAND,
                    text: 'set bounce to [BOUNCE]',
                    arguments: {
                        BOUNCE: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 0.8
                        }
                    }
                },
                {
                    opcode: 'setCollisionSize',
                    blockType: BlockType.COMMAND,
                    text: 'set collision size to [SIZE]',
                    arguments: {
                        SIZE: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 30
                        }
                    }
                },

                {
                    blockType: BlockType.LABEL,
                    text: 'World Boundary'
                },
                {
                    opcode: 'turnStageBoundary',
                    blockType: BlockType.COMMAND,
                    text: 'turn stage boundary [STATE]',
                    arguments: {
                        STATE: {
                            type: ArgumentType.STRING,
                            menu: 'onOffMenu',
                            defaultValue: 'on'
                        }
                    }
                },
                {
                    opcode: 'setBoundaryBounce',
                    blockType: BlockType.COMMAND,
                    text: 'set boundary bounce to [BOUNCE]',
                    arguments: {
                        BOUNCE: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 0.8
                        }
                    }
                },

                {
                    blockType: BlockType.LABEL,
                    text: 'Physics Reporters'
                },
                {
                    opcode: 'getVelocityX',
                    blockType: BlockType.REPORTER,
                    text: 'velocity x'
                },
                {
                    opcode: 'getVelocityY',
                    blockType: BlockType.REPORTER,
                    text: 'velocity y'
                },
                {
                    opcode: 'getSpeed',
                    blockType: BlockType.REPORTER,
                    text: 'speed'
                },
                {
                    opcode: 'getAccelerationX',
                    blockType: BlockType.REPORTER,
                    text: 'acceleration x'
                },
                {
                    opcode: 'getAccelerationY',
                    blockType: BlockType.REPORTER,
                    text: 'acceleration y'
                },
                {
                    opcode: 'getMass',
                    blockType: BlockType.REPORTER,
                    text: 'mass'
                },
                {
                    opcode: 'getNetForce',
                    blockType: BlockType.REPORTER,
                    text: 'last applied force'
                },
                {
                    opcode: 'isPhysicsOn',
                    blockType: BlockType.BOOLEAN,
                    text: 'physics engine on?'
                },
                {
                    opcode: 'isColliding',
                    blockType: BlockType.BOOLEAN,
                    text: 'this sprite is colliding?'
                }
            ],

            menus: {
                onOffMenu: {
                    acceptReporters: false,
                    items: [
                        {
                            text: 'on',
                            value: 'on'
                        },
                        {
                            text: 'off',
                            value: 'off'
                        }
                    ]
                },
                objectTypeMenu: {
                    acceptReporters: false,
                    items: [
                        {
                            text: 'dynamic',
                            value: 'dynamic'
                        },
                        {
                            text: 'static',
                            value: 'static'
                        }
                    ]
                },
                gravityDirectionMenu: {
                    acceptReporters: false,
                    items: [
                        {
                            text: 'down',
                            value: 'down'
                        },
                        {
                            text: 'up',
                            value: 'up'
                        },
                        {
                            text: 'left',
                            value: 'left'
                        },
                        {
                            text: 'right',
                            value: 'right'
                        }
                    ]
                }
            }
        };
    }

    _getDefaultState () {
        return {
            enabled: true,
            type: 'dynamic',

            mass: 1,

            vx: 0,
            vy: 0,

            ax: 0,
            ay: 0,

            fx: 0,
            fy: 0,

            lastAx: 0,
            lastAy: 0,
            lastForce: 0,

            useGravity: true,

            friction: 0,
            airResistance: 0,

            bounce: 0.8,
            collisionSize: 30,

            colliding: false
        };
    }

    _getState (target) {
        if (!target || target.isStage) return null;

        if (!this.objects.has(target.id)) {
            this.objects.set(target.id, this._getDefaultState());
        }

        return this.objects.get(target.id);
    }

    _hasState (target) {
        return target && !target.isStage && this.objects.has(target.id);
    }

    _clamp (value, min, max) {
        return Math.min(max, Math.max(min, value));
    }

    _directionToXY (amount, direction) {
        const dir = Cast.toNumber(direction);
        const radians = (90 - dir) * Math.PI / 180;

        return {
            x: amount * Math.cos(radians),
            y: amount * Math.sin(radians)
        };
    }

    _getGravityVector () {
        if (!this.gravityOn) {
            return {
                x: 0,
                y: 0
            };
        }

        const g = Cast.toNumber(this.gravityStrength);

        switch (this.gravityDirection) {
        case 'up':
            return {
                x: 0,
                y: g
            };

        case 'left':
            return {
                x: -g,
                y: 0
            };

        case 'right':
            return {
                x: g,
                y: 0
            };

        case 'down':
        default:
            return {
                x: 0,
                y: -g
            };
        }
    }

    _getRadius (target, state) {
        const manualSize = Cast.toNumber(state.collisionSize);
        if (manualSize > 0) {
            return manualSize / 2;
        }

        try {
            const bounds = target.getBounds();
            if (bounds) {
                const width = Math.abs(bounds.right - bounds.left);
                const height = Math.abs(bounds.top - bounds.bottom);
                return Math.max(8, Math.max(width, height) / 2);
            }
        } catch (e) {
            // Ignore bounds error and use default.
        }

        return 15;
    }

    _safeSetXY (target, x, y) {
        if (target && typeof target.setXY === 'function') {
            target.setXY(x, y);
        }
    }

    _step () {
        if (!this.physicsOn) {
            this.lastStepTime = null;
            return;
        }

        const now = Date.now();

        if (this.lastStepTime === null) {
            this.lastStepTime = now;
            return;
        }

        let dt = (now - this.lastStepTime) / 1000;
        this.lastStepTime = now;

        if (dt <= 0) return;

        dt = Math.min(dt, 0.05);

        const targets = this.runtime.targets || [];
        const physicsTargets = [];

        for (const target of targets) {
            if (!target || target.isStage) continue;
            if (!this.objects.has(target.id)) continue;

            const state = this.objects.get(target.id);
            if (!state || !state.enabled) continue;

            state.colliding = false;
            physicsTargets.push(target);

            if (state.type === 'static') {
                state.vx = 0;
                state.vy = 0;
                state.fx = 0;
                state.fy = 0;
                state.lastAx = 0;
                state.lastAy = 0;
                continue;
            }

            const mass = Math.max(0.001, Cast.toNumber(state.mass));
            const gravity = state.useGravity ? this._getGravityVector() : {
                x: 0,
                y: 0
            };

            const forceAx = state.fx / mass;
            const forceAy = state.fy / mass;

            const totalAx = Cast.toNumber(state.ax) + forceAx + gravity.x;
            const totalAy = Cast.toNumber(state.ay) + forceAy + gravity.y;

            state.lastAx = totalAx;
            state.lastAy = totalAy;
            state.lastForce = Math.sqrt((state.fx * state.fx) + (state.fy * state.fy));

            state.vx += totalAx * dt;
            state.vy += totalAy * dt;

            const friction = this._clamp(Cast.toNumber(state.friction), 0, 0.95);
            const airResistance = this._clamp(Cast.toNumber(state.airResistance), 0, 0.95);

            const damping = Math.pow(Math.max(0, 1 - friction - airResistance), dt * 60);

            state.vx *= damping;
            state.vy *= damping;

            const newX = target.x + (state.vx * dt);
            const newY = target.y + (state.vy * dt);

            this._safeSetXY(target, newX, newY);

            state.fx = 0;
            state.fy = 0;

            if (this.stageBoundaryOn) {
                this._handleStageBoundary(target, state);
            }
        }

        this._handleObjectCollisions(physicsTargets);
    }

    _handleStageBoundary (target, state) {
        const radius = this._getRadius(target, state);
        const bounce = this._clamp(Cast.toNumber(state.bounce) * Cast.toNumber(this.boundaryBounce), 0, 1);

        const left = -240 + radius;
        const right = 240 - radius;
        const bottom = -180 + radius;
        const top = 180 - radius;

        let x = target.x;
        let y = target.y;

        if (x < left) {
            x = left;
            state.vx = Math.abs(state.vx) * bounce;
            state.colliding = true;
        }

        if (x > right) {
            x = right;
            state.vx = -Math.abs(state.vx) * bounce;
            state.colliding = true;
        }

        if (y < bottom) {
            y = bottom;
            state.vy = Math.abs(state.vy) * bounce;
            state.colliding = true;
        }

        if (y > top) {
            y = top;
            state.vy = -Math.abs(state.vy) * bounce;
            state.colliding = true;
        }

        this._safeSetXY(target, x, y);
    }

    _handleObjectCollisions (targets) {
        for (let i = 0; i < targets.length; i++) {
            const targetA = targets[i];
            const stateA = this.objects.get(targetA.id);

            for (let j = i + 1; j < targets.length; j++) {
                const targetB = targets[j];
                const stateB = this.objects.get(targetB.id);

                if (!stateA || !stateB) continue;
                if (stateA.type === 'static' && stateB.type === 'static') continue;

                const radiusA = this._getRadius(targetA, stateA);
                const radiusB = this._getRadius(targetB, stateB);

                const dx = targetB.x - targetA.x;
                const dy = targetB.y - targetA.y;

                let distance = Math.sqrt((dx * dx) + (dy * dy));

                if (distance === 0) {
                    distance = 0.001;
                }

                const minDistance = radiusA + radiusB;

                if (distance >= minDistance) continue;

                const nx = dx / distance;
                const ny = dy / distance;

                const overlap = minDistance - distance;

                const invMassA = stateA.type === 'static' ? 0 : 1 / Math.max(0.001, Cast.toNumber(stateA.mass));
                const invMassB = stateB.type === 'static' ? 0 : 1 / Math.max(0.001, Cast.toNumber(stateB.mass));

                const totalInvMass = invMassA + invMassB;

                if (totalInvMass <= 0) continue;

                const correctionA = overlap * (invMassA / totalInvMass);
                const correctionB = overlap * (invMassB / totalInvMass);

                if (stateA.type !== 'static') {
                    this._safeSetXY(
                        targetA,
                        targetA.x - (nx * correctionA),
                        targetA.y - (ny * correctionA)
                    );
                }

                if (stateB.type !== 'static') {
                    this._safeSetXY(
                        targetB,
                        targetB.x + (nx * correctionB),
                        targetB.y + (ny * correctionB)
                    );
                }

                const rvx = stateB.vx - stateA.vx;
                const rvy = stateB.vy - stateA.vy;

                const velocityAlongNormal = (rvx * nx) + (rvy * ny);

                if (velocityAlongNormal > 0) {
                    stateA.colliding = true;
                    stateB.colliding = true;
                    continue;
                }

                const bounce = this._clamp(Math.min(
                    Cast.toNumber(stateA.bounce),
                    Cast.toNumber(stateB.bounce)
                ), 0, 1);

                const impulse = -(1 + bounce) * velocityAlongNormal / totalInvMass;

                if (stateA.type !== 'static') {
                    stateA.vx -= impulse * invMassA * nx;
                    stateA.vy -= impulse * invMassA * ny;
                }

                if (stateB.type !== 'static') {
                    stateB.vx += impulse * invMassB * nx;
                    stateB.vy += impulse * invMassB * ny;
                }

                stateA.colliding = true;
                stateB.colliding = true;
            }
        }
    }

    turnPhysicsEngine (args) {
        this.physicsOn = args.STATE === 'on';

        if (this.physicsOn) {
            this._startLoop();
        } else {
            this._stopLoop();
        }
    }

    makePhysicsObject (args, util) {
        const state = this._getState(util.target);
        if (!state) return;

        state.enabled = true;
        state.type = args.TYPE === 'static' ? 'static' : 'dynamic';

        if (state.type === 'static') {
            state.vx = 0;
            state.vy = 0;
            state.ax = 0;
            state.ay = 0;
            state.fx = 0;
            state.fy = 0;
        }
    }

    removePhysicsObject (args, util) {
        if (!util.target || util.target.isStage) return;
        this.objects.delete(util.target.id);
    }

    resetThisPhysics (args, util) {
        const state = this._getState(util.target);
        if (!state) return;

        const oldType = state.type;
        const oldMass = state.mass;
        const oldCollisionSize = state.collisionSize;

        Object.assign(state, this._getDefaultState());

        state.type = oldType;
        state.mass = oldMass;
        state.collisionSize = oldCollisionSize;
    }

    clearAllPhysics () {
        this.objects.clear();
    }

    setVelocityXY (args, util) {
        const state = this._getState(util.target);
        if (!state) return;

        state.vx = Cast.toNumber(args.VX);
        state.vy = Cast.toNumber(args.VY);
    }

    changeVelocityXY (args, util) {
        const state = this._getState(util.target);
        if (!state) return;

        state.vx += Cast.toNumber(args.VX);
        state.vy += Cast.toNumber(args.VY);
    }

    setSpeedDirection (args, util) {
        const state = this._getState(util.target);
        if (!state) return;

        const speed = Cast.toNumber(args.SPEED);
        const vector = this._directionToXY(speed, args.DIR);

        state.vx = vector.x;
        state.vy = vector.y;
    }

    setAccelerationXY (args, util) {
        const state = this._getState(util.target);
        if (!state) return;

        state.ax = Cast.toNumber(args.AX);
        state.ay = Cast.toNumber(args.AY);
    }

    launchSprite (args, util) {
        const state = this._getState(util.target);
        if (!state) return;

        const speed = Cast.toNumber(args.SPEED);
        const vector = this._directionToXY(speed, args.ANGLE);

        state.vx = vector.x;
        state.vy = vector.y;
    }

    stopMotion (args, util) {
        const state = this._getState(util.target);
        if (!state) return;

        state.vx = 0;
        state.vy = 0;
        state.fx = 0;
        state.fy = 0;
    }

    turnGravity (args) {
        this.gravityOn = args.STATE === 'on';
    }

    useGravityForSprite (args, util) {
        const state = this._getState(util.target);
        if (!state) return;

        state.useGravity = args.STATE === 'on';
    }

    setGravityStrength (args) {
        this.gravityStrength = Cast.toNumber(args.G);
    }

    setGravityDirection (args) {
        this.gravityDirection = String(args.DIR);
    }

    setMass (args, util) {
        const state = this._getState(util.target);
        if (!state) return;

        state.mass = Math.max(0.001, Cast.toNumber(args.MASS));
    }

    applyForceXY (args, util) {
        const state = this._getState(util.target);
        if (!state) return;

        state.fx += Cast.toNumber(args.FX);
        state.fy += Cast.toNumber(args.FY);
    }

    applyForceDirection (args, util) {
        const state = this._getState(util.target);
        if (!state) return;

        const force = Cast.toNumber(args.FORCE);
        const vector = this._directionToXY(force, args.DIR);

        state.fx += vector.x;
        state.fy += vector.y;
    }

    setFriction (args, util) {
        const state = this._getState(util.target);
        if (!state) return;

        state.friction = this._clamp(Cast.toNumber(args.FRICTION), 0, 0.95);
    }

    setAirResistance (args, util) {
        const state = this._getState(util.target);
        if (!state) return;

        state.airResistance = this._clamp(Cast.toNumber(args.AIR), 0, 0.95);
    }

    setBounce (args, util) {
        const state = this._getState(util.target);
        if (!state) return;

        state.bounce = this._clamp(Cast.toNumber(args.BOUNCE), 0, 1);
    }

    setCollisionSize (args, util) {
        const state = this._getState(util.target);
        if (!state) return;

        state.collisionSize = Math.max(1, Cast.toNumber(args.SIZE));
    }

    turnStageBoundary (args) {
        this.stageBoundaryOn = args.STATE === 'on';
    }

    setBoundaryBounce (args) {
        this.boundaryBounce = this._clamp(Cast.toNumber(args.BOUNCE), 0, 1);
    }

    getVelocityX (args, util) {
        const state = this._hasState(util.target) ? this.objects.get(util.target.id) : null;
        return state ? state.vx : 0;
    }

    getVelocityY (args, util) {
        const state = this._hasState(util.target) ? this.objects.get(util.target.id) : null;
        return state ? state.vy : 0;
    }

    getSpeed (args, util) {
        const state = this._hasState(util.target) ? this.objects.get(util.target.id) : null;
        if (!state) return 0;

        return Math.sqrt((state.vx * state.vx) + (state.vy * state.vy));
    }

    getAccelerationX (args, util) {
        const state = this._hasState(util.target) ? this.objects.get(util.target.id) : null;
        return state ? state.lastAx : 0;
    }

    getAccelerationY (args, util) {
        const state = this._hasState(util.target) ? this.objects.get(util.target.id) : null;
        return state ? state.lastAy : 0;
    }

    getMass (args, util) {
        const state = this._hasState(util.target) ? this.objects.get(util.target.id) : null;
        return state ? state.mass : 0;
    }

    getNetForce (args, util) {
        const state = this._hasState(util.target) ? this.objects.get(util.target.id) : null;
        return state ? state.lastForce : 0;
    }

    isPhysicsOn () {
        return this.physicsOn;
    }

    isColliding (args, util) {
        const state = this._hasState(util.target) ? this.objects.get(util.target.id) : null;
        return state ? state.colliding : false;
    }
}

module.exports = Scratch3MadBotPhysicsLab;